// extracted by mini-css-extract-plugin
module.exports = {"Hero":"Hero_Hero__1ehKd","container":"Hero_container__1609r","searchBox":"Hero_searchBox__2ZLkg"};